import React from 'react';
import TopPostIcon from '../../img/top_post.svg';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const TopPost = () => {
  const classes = useStyles();
  return (
    <Box className={classes.topPostBox}>
      <img src={TopPostIcon} alt="Top post icon" />
      <Typography
        variant="caption"
        className={classes.topPostText}
        component="span"
      >
        Top Post
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  topPostText: {
    position: 'absolute',
    top: '3px',
    right: '20px',
  },
  topPostBox: {
    position: 'relative',
    display: 'inline-block',
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
  },
}));

export default TopPost;
